import { nutritionMatrix, menuWeeks } from "@/data/menu";

export const NutritionMatrix = () => (
  <div data-testid="nutrition-matrix">
    {/* Desktop comparison table */}
    <div className="hidden overflow-hidden rounded-card bg-surface shadow-soft lg:block">
      <table className="w-full border-collapse text-left text-sm">
        <caption className="sr-only">
          Approximate calories and protein for each meal across the three menu weeks
        </caption>
        <thead>
          <tr className="bg-forest text-white">
            <th scope="col" className="px-4 py-4 font-heading text-xs font-semibold uppercase tracking-[0.12em]">
              Day
            </th>
            {menuWeeks.map((w) => (
              <th
                key={w.id}
                scope="col"
                className="px-4 py-4 font-heading text-xs font-semibold uppercase tracking-[0.12em]"
              >
                Week {w.number} — {w.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {nutritionMatrix.map((row, i) => (
            <tr key={row.day} className={i % 2 ? "bg-creamDeep/50" : ""}>
              <th scope="row" className="px-4 py-5 align-top font-heading text-sm font-semibold text-coralInk">
                {row.day}
              </th>
              {row.weeks.map((cell) => (
                <td key={cell.weekNumber} className="px-4 py-5 align-top">
                  <p className="font-medium text-cocoa">{cell.name}</p>
                  <p className="mt-1.5 flex gap-3 text-[13px] text-cocoa/70">
                    {cell.calories === null ? (
                      <span className="text-cocoa/70">Nutrition being confirmed</span>
                    ) : (
                      <>
                        <span className="font-semibold text-coralInk">{cell.calories} kcal</span>
                        <span>{cell.protein} g protein</span>
                      </>
                    )}
                  </p>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Mobile stacked cards */}
    <div className="flex flex-col gap-4 lg:hidden">
      {nutritionMatrix.map((row) => (
        <div key={row.day} className="mbm-card p-5" data-testid={`matrix-card-${row.day.toLowerCase()}`}>
          <h3 className="font-heading text-base font-semibold">{row.day}</h3>
          <ul className="mt-3 space-y-3">
            {row.weeks.map((cell) => (
              <li key={cell.weekNumber} className="border-t border-line pt-3">
                <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-rust">
                  Week {cell.weekNumber}
                </p>
                <p className="mt-1 text-sm font-medium text-cocoa">{cell.name}</p>
                <p className="mt-1 flex gap-3 text-[13px] text-cocoa/70">
                  {cell.calories === null ? (
                    <span className="text-cocoa/70">Nutrition being confirmed</span>
                  ) : (
                    <>
                      <span className="font-semibold text-coralInk">{cell.calories} kcal</span>
                      <span>{cell.protein} g protein</span>
                    </>
                  )}
                </p>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <p className="mt-5 text-xs leading-relaxed text-cocoa/65">
      Nutrition values are approximate and taken from the current menu guide. Values that
      have not been confirmed are left blank rather than estimated.
    </p>
  </div>
);

export default NutritionMatrix;
